/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AmsParametersResponse,
  ProblemDetails,
  UpdateAmsParametersRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    AmsParametersResponseFromJSON,
    AmsParametersResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateAmsParametersRequestFromJSON,
    UpdateAmsParametersRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface UpdateAmsParametersOperationRequest {
    updateAmsParametersRequest: UpdateAmsParametersRequest;
}

/**
 * AmsParametersApi - interface
 * 
 * @export
 * @interface AmsParametersApiInterface
 */
export interface AmsParametersApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmsParametersApiInterface
     */
    getAmsParametersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmsParametersResponse>>;

    /**
     */
    getAmsParameters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmsParametersResponse>;

    /**
     * 
     * @param {UpdateAmsParametersRequest} updateAmsParametersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmsParametersApiInterface
     */
    updateAmsParametersRaw(requestParameters: UpdateAmsParametersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmsParametersResponse>>;

    /**
     */
    updateAmsParameters(requestParameters: UpdateAmsParametersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmsParametersResponse>;

}

/**
 * 
 */
export class AmsParametersApi extends runtime.BaseAPI implements AmsParametersApiInterface {

    /**
     */
    async getAmsParametersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmsParametersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/ams-parameters`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AmsParametersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAmsParameters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmsParametersResponse> {
        const response = await this.getAmsParametersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAmsParametersRaw(requestParameters: UpdateAmsParametersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmsParametersResponse>> {
        if (requestParameters['updateAmsParametersRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAmsParametersRequest',
                'Required parameter "updateAmsParametersRequest" was null or undefined when calling updateAmsParameters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/ams-parameters`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAmsParametersRequestToJSON(requestParameters['updateAmsParametersRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AmsParametersResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateAmsParameters(requestParameters: UpdateAmsParametersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmsParametersResponse> {
        const response = await this.updateAmsParametersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
